'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.caches = exports.sheet = exports.cssWithScope = exports.css = exports.keyframes = exports.injectGlobal = exports.getRegisteredStyles = exports.merge = exports.cx = exports.hydrate = exports.flush = undefined;

var _index = require('../create-emotion/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = (0, _index2.default)(context);

var flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    cssWithScope = _createEmotion.cssWithScope,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;
exports.flush = flush;
exports.hydrate = hydrate;
exports.cx = cx;
exports.merge = merge;
exports.getRegisteredStyles = getRegisteredStyles;
exports.injectGlobal = injectGlobal;
exports.keyframes = keyframes;
exports.css = css;
exports.cssWithScope = cssWithScope;
exports.sheet = sheet;
exports.caches = caches;